/**
 * Хранение токена сессии на фронте.
 *
 * Токен (не cookie) — единообразно работает в кросс-сайтовом iframe Битрикса и в
 * standalone. Кладём в localStorage и подставляем в Authorization для всех /api-запросов.
 */
const KEY = 'ts_session_token';

let cached: string | null | undefined;

export function getToken(): string | null {
  if (cached !== undefined) return cached;
  try {
    cached = localStorage.getItem(KEY);
  } catch {
    cached = null;
  }
  return cached;
}

export function setToken(token: string | null): void {
  cached = token;
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* приватный режим / недоступный storage — токен живёт в памяти процесса */
  }
}

/** Заголовки авторизации для fetch к /api/*. */
export function authHeaders(): Record<string, string> {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// ── Реакция на «вход протух» (сервер ответил 401) ──────────
let unauthorizedHandler: (() => void) | null = null;

/** Стор регистрирует, что делать при 401 (разлогинить, показать вход). */
export function setUnauthorizedHandler(fn: () => void): void {
  unauthorizedHandler = fn;
}

/** Вызывается слоем данных при 401 от сервера. */
export function notifyUnauthorized(): void {
  unauthorizedHandler?.();
}
